import Chart from 'chart.js'
import {
  setInitialHiddenState,
  legendItemsRefs,
  barLegendOptions,
  bindChartEvents,
} from './util/barLegend.js'
import scales from './util/scales'

function generateChart(chartId, chartType) {
  return {
    render: function (createElement) {
      return createElement('div', null, [
        createElement('span', {
          ref: 'legend',
          class: ['legend-wrapper'],
        }),
        createElement(
          'div',
          {
            style: this.styles,
            class: this.cssClasses,
          },
          [
            createElement('canvas', {
              attrs: {
                id: this.chartId,
                width: `${this.width}px`,
                height: `${this.height}px`,
              },
              ref: 'canvas',
            }),
          ]
        ),
      ])
    },

    props: {
      chartId: {
        default: chartId,
        type: String,
      },
      width: {
        default: 400,
        type: Number,
      },
      height: {
        default: 400,
        type: Number,
      },
      cssClasses: {
        type: String,
        default: '',
      },
      styles: {
        type: Object,
      },
      plugins: {
        type: Array,
        default() {
          return []
        },
      },
    },

    data() {
      return {
        _chart: null,
        _plugins: this.plugins,
      }
    },

    methods: {
      addPlugin(plugin) {
        this.$data._plugins.push(plugin)
      },
      generateLegend($el = this.$refs.legend) {
        if (this.$data._chart) {
          if ($el) {
            $el.insertAdjacentHTML('afterbegin', this.$data._chart.generateLegend())
          }
        }
      },
      renderChart(data, options) {
        // prettier-ignore
        if (!this.$refs.canvas) throw new Error('Please remove the <template></template> tags from your chart component. See https://vue-chartjs.org/guide/#vue-single-file-components')
        if (this.$data._chart) this.$data._chart.destroy()

        const chart = new Chart(this.$refs.canvas.getContext('2d'), {
          type: chartType,
          data: data,
          options: {
            ...options,
            ...barLegendOptions,
            scales,
          },
          plugins: this.$data._plugins,
        })

        this.$data._chart = chart

        // Generate Custom legend
        // https://www.chartjs.org/docs/latest/configuration/legend.html
        this.generateLegend()

        bindChartEvents(chart, document)

        setInitialHiddenState()
      },
    },
    beforeDestroy() {
      legendItemsRefs.forEach((removeListeners) => removeListeners())

      if (this.$data._chart) {
        this.$data._chart.destroy()
      }
    },
  }
}

export const Bar = generateChart('bar-chart', 'bar')
export const HorizontalBar = generateChart('horizontalbar-chart', 'horizontalBar')
export const Doughnut = generateChart('doughnut-chart', 'doughnut')
export const Line = generateChart('line-chart', 'line')
export const Pie = generateChart('pie-chart', 'pie')
export const PolarArea = generateChart('polar-chart', 'polarArea')
export const Radar = generateChart('radar-chart', 'radar')
export const Bubble = generateChart('bubble-chart', 'bubble')
export const Scatter = generateChart('scatter-chart', 'scatter')
